"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMobile = void 0;
var react_1 = require("react");
var isMobile = function () { return window.innerWidth < 425; };
var isTablet = function () { return window.innerWidth < 768; };
var windowWidth = function () { return window.innerWidth; };
var useMobile = function () {
    var _a = (0, react_1.useState)(isMobile()), mobile = _a[0], setMobile = _a[1];
    var _b = (0, react_1.useState)(isTablet()), tablet = _b[0], setTablet = _b[1];
    var _c = (0, react_1.useState)(windowWidth()), width = _c[0], setWidth = _c[1];
    (0, react_1.useEffect)(function () {
        function handleResize() {
            setMobile(isMobile());
            setTablet(isTablet());
            setWidth(windowWidth());
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return function () { return window.removeEventListener('resize', handleResize); };
    }, [setMobile, setTablet, setWidth]);
    return { mobile: mobile, tablet: tablet, width: width };
};
exports.useMobile = useMobile;
